/**
 * Constants shared by a slot and the chrome that hangs off it.
 *
 * Sizing lives in `chassisVars` instead — a slot's footprint is part of the chassis grid, so it has
 * to agree with the card's padding and gaps.
 */
export const slotVars = {
  /**
   * Stacking order within one slot. The caption sits under the glyph, the focus target over both,
   * and a connection between them — a chip hangs outside the slot's own box, so this only decides
   * which one wins where it overhangs a neighbour. `connectionRaised` is where a chip goes while it
   * is pointed at, since a chip carrying a name is wider than its slot and starts out partly covered.
   *
   * `traceRaised` belongs to the chassis, not a slot: it clears `target`, and since chips draw under
   * `target` a raised line covers them too — hence `connectionRaised` above it.
   */
  zIndex: {
    caption: 1,
    diagram: 2,
    connection: 3,
    target: 4,
    badge: 5,
    traceRaised: 6,
    connectionRaised: 7,
  },
  /**
   * How far off the slot each lane of connection chips sits, to the far side of the pill. Shared
   * with `ChassisTraces`, which bows its lines clear of `far`.
   */
  chipLane: {
    near: 28,
    far: 52,
  },
  /** Opacity of a slot the legend has filtered out. */
  mutedOpacity: 0.3,
};
